import React from 'react';
import {Helmet} from "react-helmet";


class TitleText extends React.Component {
    render(){
        return(
            <div className="wordingCarousel" data-aos={"fade-up"} style={{width: "auto"}}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Vancouver Mobile App Development Company - Compile Labs</title>
                <meta name="og:title" property="og:title" content="Vancouver Mobile App Development Company - Compile Labs"></meta>
                <meta name="description" content="Compile Labs is a mobile app development agency in Vancouver, we design and develop IOS and Android apps with focus towards UI/UX." />
                <meta name="og:description" content="Compile Labs is a mobile app development agency in Vancouver, we design and develop IOS and Android apps with 
                focus towards UI/UX." />
               
            </Helmet>
                <div className="inner">
                    Vancouver  app design <br/>
                    and development company
                </div>
            </div>
        );
    }

}


export default TitleText;